import type { CustomThemeConfig } from '@pba/react-theme';
import { Flex as FlexAntd, type FlexProps } from 'antd';
import cn from 'classnames';
import { useResolveSpacingValue } from '../hooks';
import styles from './flex.module.css';
import { useGetGap } from './hooks';

export type FlexProperties = {
  marginHorizontal?: SpacingValue;
  marginVertical?: SpacingValue;
  paddingHorizontal?: SpacingValue;
  paddingVertical?: SpacingValue;
} & FlexProps;

type SpacingValue = keyof CustomThemeConfig['spacing'];

const Flex = ({
  className,
  gap,
  marginHorizontal,
  marginVertical,
  paddingHorizontal,
  paddingVertical,
  style,
  ...props
}: FlexProperties) => {
  const resolvedGap = useGetGap({ gap });
  const resolveSpacingValue = useResolveSpacingValue();

  const toCss = (value?: SpacingValue) => (value === undefined ? undefined : `${resolveSpacingValue({ value })}px`);

  return (
    <FlexAntd
      className={cn(className, styles.flex)}
      gap={resolvedGap}
      style={{
        ...style,
        ['--flex-margin-horizontal' as string]: toCss(marginHorizontal),
        ['--flex-margin-vertical' as string]: toCss(marginVertical),
        ['--flex-padding-horizontal' as string]: toCss(paddingHorizontal),
        ['--flex-padding-vertical' as string]: toCss(paddingVertical),
      }}
      {...props}
    />
  );
};

export default Flex;
